import { GalleryCard } from "../_00Global/GalleryCard";

export const _08BBody = (): JSX.Element => {
  return (
    <div className="flex flex-col items-center justify-center relative mb-[100px]">
      <div className="w-full max-w-[1100px] px-4">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-y-10 gap-x-10 lg:gap-[70px_100px] py-[30px] justify-items-center mx-auto max-w-[750px] lg:max-w-none">
          <GalleryCard
            image="/img/image-5.png"
            text="Watch anywhere, anytime directly from the phone<br />in your pocket."
            text1="Phone"
          />
          <GalleryCard
            image="/img/image-4.png"
            text="Or for an even bigger mobile experience; watch it from your tablet."
            text1="Tablet"
          />
          <GalleryCard
            image="/img/image-3.png"
            text="Obviously, your custom  film can also be viewed on your Laptop/Computer."
            text1="Laptop"
          />
          <GalleryCard
            image="/img/image-2.png"
            text="Enjoy your film on the big<br />screen with our full 4K<br />resolution."
            text1="Smart Tv"
          />
          <GalleryCard
            image="/img/image-1.png"
            text="Easily share your online<br />gallery with an unlimited<br />number of friends."
            text1="Sharing"
          />
          <GalleryCard
            image="/img/image.png"
            text="Easily download so you can put them on a DVD or USB for family."
            text1="Download"
          />
        </div>
      </div>
    </div>
  );
}; 